import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState: any = {
  loading: false,
  mfgLookupList: [],
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
  filter: null,
  reset: false
};

const slice = createSlice({
  name: 'mfgLookup',
  initialState,
  reducers: {
    setMfgLookupList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.mfgLookupList = payload || [];
      state.reset = false;
    },
    setTotalCount: (state, { payload }: PayloadAction<any>) => {
      state.totalCount = payload;
    },
    setCurrentPage: (state, { payload }: PayloadAction<any>) => {
      state.currentPage = payload;
    },
    setPageSize: (state, { payload }: PayloadAction<any>) => {
      state.pageSize = payload;
    },
    setFilter: (state, { payload }: PayloadAction<any>) => {
      state.filter = payload;
    },
    reset: (state) => {
      state.reset = true;
    }
  }
});

export const { setMfgLookupList, setTotalCount, setCurrentPage, setPageSize, setFilter, reset } =
  slice.actions;

export default slice.reducer;
